<template>
  <div class="tag-wrapper" v-click-outside="closeForm">
    <div class="tag">
      <span class="tag-head" @click="toggleForm">
        <template v-if="multiple">
          {{headerLabel}}: <span class="tagsList">{{data.min}} - {{data.max}}</span>
        </template>
        <template v-else>
          {{headerLabel}}: <span class="tagsList">{{data}}</span>
        </template>
      </span>
      <span class="tag-close" @click="removeTag">
        <i class="close"></i>
      </span>
      <div class="tag-data" v-if="showTagData">
        <div class="tag-select-wrapper">
          <div class="tag-wrapper">
            <template v-if="multiple">
                <input type="text" v-model="data.min" v-on:keyup.enter="saveChanges()">
                <input type="text" v-model="data.max" v-on:keyup.enter="saveChanges()">
            </template>
            <template v-else>
              <input type="text" v-model="data" v-on:keyup.enter="saveChanges()">
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "cc-filter-tag-input",
    components: {

    },
    props: {
      value: {
        type: [String, Number, Object],
        required: true
      },
      fieldName: {
        type: String,
        required: true
      },
      headerLabel: {
        type: String,
        required: true
      },
      actionEvent: {
        type: Function,
        required: true
      },
      removeEvent: {
        type: Function,
        required: true
      },
      multiple: {
        type: Boolean,
        required: false
      }
    },
    data(){
      return {
        showTagData: false,
        data: this.value
      }
    },
    computed: {
    },
    watch: {
      value: function(newValue){
        this.data = newValue;
      }
    },
    methods: {
      toggleForm: function(){
        this.showTagData = !this.showTagData;
      },
      closeForm: function(){
        this.showTagData = false;
      },
      removeTag: function(){
        this.showTagData = false;

        if (this.multiple)
        {
          this.data = {'min': null, 'max': null}          
        }
        else
        {
          this.data = null;
        }
        this.removeEvent(this.data);
      },
      closeTagForm: function(){
        this.showTagData = false;
      },
      saveChanges: function(){
        this.actionEvent(this.data);
        this.closeTagForm();
      }
    }
  }
</script>

<style lang="scss" scoped>

  .tag-wrapper {
    text-align: left;
  }

  .tag {
    background-color: $tag-background;
    border: 1px solid $tag-background;
    border-radius: 2px;
    color: $tag-color;
    padding: 4px 10px 4px 10px;
    display: inline-block;
    float: left;
    margin: 1px 0.25rem 0 0.25rem;
    font-size: 14px;
  }

  .tagsList {
    cursor: pointer;
    font-weight: bold;
  }

  .tag-head {
    color: #fff;
    cursor: pointer;
  }

  .tag-data .tag-select-wrapper .tag-wrapper .sitesListFilter {
    color: #000;
    border: 0;
    padding: 0px 0px 5px 0px;
    float: none;
    margin: 0;
  }

  .tag-close {
    padding-left: 10px;

    & > i.close {
      display: inline-block;
      width: 0.7em;
      height: 0.7em;
      color: #fff;
      background-image: url('/static/img/icon-filter-close.svg');
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
    }
  }

  .tag-select-wrapper {
    display: inline-block;
    z-index: 999999;
    position: absolute;
    background-color: #fff;
    margin-left: -12px;
    margin-top: 5px;

    .tag-wrapper {
      padding: 10px;

      & > label {
        color: #2c3e50;
      }

      & > input{
        padding: 5px;
        border: 1px solid #d7d7d7;
        border-radius: 2px;
        text-align: center;

        &::placeholder {
          color: #c6c6c6;
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/common/CCFilterTagInput.vue